'use strict';

exports.__esModule = true;
exports.resultsActions = exports.UPDATE_SELECTED_PAGE = exports.UPDATE_AVAILABILITY = exports.ON_MARKER_CLICKED = exports.ON_MARKER_CLOSED = exports.LOADING_RESULTS = exports.UPDATE_RESULTS = exports.UPDATE_MARKERS = exports.RESULT_HOVER = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _doctifyUtils = require('doctify-utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.
var APPOINTMENTS = 'appointments';
var RESULT_HOVER = exports.RESULT_HOVER = 'SEARCH_ACTIONS:RESULT_HOVER';
var UPDATE_MARKERS = exports.UPDATE_MARKERS = 'SEARCH_ACTIONS:UDPATE_MARKERS';
var UPDATE_RESULTS = exports.UPDATE_RESULTS = 'SEARCH_ACTIONS:UPDATE_RESULTS';
var LOADING_RESULTS = exports.LOADING_RESULTS = 'SEARCH_ACTIONS:LOADING_RESULTS';
var ON_MARKER_CLOSED = exports.ON_MARKER_CLOSED = 'SEARCH_ACTIONS:ON_MARKER_CLOSED';
var ON_MARKER_CLICKED = exports.ON_MARKER_CLICKED = 'SEARCH_ACTIONS:ON_MARKER_CLICKED';
var UPDATE_AVAILABILITY = exports.UPDATE_AVAILABILITY = 'SEARCH_ACTIONS:UPDATE_AVAILABILITY';
var UPDATE_SELECTED_PAGE = exports.UPDATE_SELECTED_PAGE = 'SEARCH_ACTIONS:UPDATE_SELECTED_PAGE';

var resultsActions = exports.resultsActions = {
	onMarkerClicked: function onMarkerClicked(marker) {
		return {
			type: ON_MARKER_CLICKED,
			marker: marker
		};
	},
	onMarkerClosed: function onMarkerClosed(marker) {
		return {
			type: ON_MARKER_CLOSED,
			marker: marker
		};
	},
	onPageClicked: function onPageClicked(page) {
		return {
			type: UPDATE_SELECTED_PAGE,
			page: page
		};
	},
	onHover: function onHover(id) {
		return {
			type: RESULT_HOVER,
			id: id
		};
	},
	updateSelectedPage: function updateSelectedPage(page) {
		return {
			type: UPDATE_SELECTED_PAGE,
			page: page
		};
	},
	updateMarkers: function updateMarkers(markers) {
		return {
			type: UPDATE_MARKERS,
			markers: markers
		};
	},
	updateResults: function updateResults(parameters, searchType, listings, searchedNetwork, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: searchType === APPOINTMENTS ? 'search' : 'directory/search',
			method: 'GET',
			parameters: searchType === APPOINTMENTS ? parameters : (0, _extends3.default)({}, parameters, {
				pageoffset: parameters.page_offset,
				pagesize: parameters.page_limit
			}),
			actionType: UPDATE_RESULTS,
			actionData: {
				listings: listings,
				searchType: searchType,
				searchedNetwork: searchedNetwork
			},
			xhrConfig: xhrConfig
		});
	},
	loadingResults: function loadingResults() {
		return {
			type: LOADING_RESULTS
		};
	},
	updateAvailabilities: function updateAvailabilities(actionData, parameters) {
		var newParameters = (0, _assign2.default)({}, parameters);
		var newActionData = (0, _assign2.default)({}, actionData);
		var twoDaysAfterToday = (0, _moment2.default)().add(2, 'days').format('YYYY-MM-DD HH:mm');
		if (parameters && parameters.startdate && (0, _moment2.default)(parameters.startdate).isBefore(twoDaysAfterToday)) {
			var durationHours = _moment2.default.duration((0, _moment2.default)(newParameters.enddate).diff((0, _moment2.default)(newParameters.startdate))).asHours();
			var newEndDate = (0, _moment2.default)(twoDaysAfterToday).add(durationHours, 'hours').format('YYYY-MM-DD HH:mm');
			newParameters = (0, _assign2.default)({}, newParameters, { startdate: twoDaysAfterToday, enddate: newEndDate });
			newActionData = (0, _assign2.default)({}, newActionData, { startDate: twoDaysAfterToday });
		} else if ((0, _moment2.default)(parameters.startdate).isSame((0, _moment2.default)().format('YYYY-MM-DD'))) {
			newParameters = (0, _assign2.default)({}, newParameters, { startdate: (0, _moment2.default)().format('YYYY-MM-DD HH:mm') });
		}
		return (0, _doctifyUtils.createAction)({
			url: newActionData.profileUrl + '/availability',
			method: 'GET',
			parameters: newParameters,
			actionData: newActionData,
			actionType: UPDATE_AVAILABILITY
		});
	}
};


// WEBPACK FOOTER //
// ./components/search-page/lib/actions/results-actions.js